'use strict';

module.exports = function () {
	try {
		Object.keys('primitive');
		return true;
	} catch (e) { return false; }
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/es5-ext/object/keys/is-implemented.js
 ** module id = 67
 ** module chunks = 2
 **/